import { UserOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { Form, Button, Input } from "antd";

import PasswordFormItem from "../passwordFormItem";
import LoginFormContainer from "../loginFormContainer";

const { Item } = Form;

const LoginForm = ({ onFinish, loading }) => {
  const intl = useIntl();
  return (
    <LoginFormContainer>
      <Form onFinish={onFinish}>
        <Item
          name="username"
          rules={[
            {
              required: true,
              message: (
                <FormattedMessage
                  id="login.username.error"
                  defaultMessage="Vyplňte prosím uživatelské jméno!"
                />
              ),
            },
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder={intl.formatMessage({
              id: "login.username",
              defaultMessage: "uživatelské jméno",
            })}
            autoComplete="username"
          />
        </Item>
        <PasswordFormItem
          fieldName="password"
          placeHolder={intl.formatMessage({
            id: "login.password",
            defaultMessage: "heslo",
          })}
          autoComplete="current-password"
          message={
            <FormattedMessage
              id="login.password.error"
              defaultMessage="Vyplňte prosím heslo!"
            />
          }
        />
        <Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            <FormattedMessage id="login" defaultMessage="Přihlásit se" />
          </Button>
        </Item>
      </Form>
    </LoginFormContainer>
  );
};

export default LoginForm;
